var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"topbanner",attrs:{"aria-label":("" + _vm.page_title)}},[_c('h2',{attrs:{"aria-hidden":"true"}},[_vm._v("센터소개")])]),_vm._v(" "),_c('article',{staticClass:"main_contents"},[_c('div',{staticClass:"main_contents_insub",domProps:{"innerHTML":_vm._s(_vm.page_contents)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5326504e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sub.vue
// module id = null
// module chunks = 